import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRegistrationService } from '../../services/user-registration.service';
import { LayoutQuery } from '../../../layout/state/layout.query';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
  standalone: false,
})
export class SetPasswordComponent implements OnInit {
  [x: string]: any;
  id!: string;
  showError: boolean = false;
  profileForm!: FormGroup;
  showSpinner: boolean = false;
  forgotpass: boolean = false;

  constructor(
    private service: UserRegistrationService,
    private router: Router,
    private activateroute: ActivatedRoute,
    public layoutQuery: LayoutQuery,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.id = this.activateroute.snapshot.params['guid'];
    this.forgotpass = this.activateroute.snapshot.params['forgotpass'] === 'true';

    this.profileForm = this.fb.group({
      password: ['', [
        Validators.required,
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+]).{8,100}$/)
      ]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordsMatchValidator });
  }

  // Validator that checks password and confirmPassword match
  passwordsMatchValidator(group: AbstractControl): ValidationErrors | null {
    const password = group.get('password')?.value;
    const confirmControl = group.get('confirmPassword');
    if (!confirmControl) return null;

    const errors = { ...(confirmControl.errors || {}) };
    if (password !== confirmControl.value) {
      confirmControl.setErrors({ ...errors, mismatch: true });
      return { mismatch: true };
    } else {
      delete errors['mismatch'];
      confirmControl.setErrors(Object.keys(errors).length ? errors : null);
      return null;
    }
  }

  validate(control: string) {
    return this.profileForm.get(control);
  }

  update(): void {
    if (this.profileForm.invalid) return;

    this.showSpinner = true;
    const password = this.profileForm.value.password;

    this.service.updatePassWord(this.id, password).subscribe({
      next: (response) => {
        if (response) {
          this.router.navigate([`user-registration/pwd-success/${this.id}`]);
        } else {
          this.handleError();
        }
      },
      error: () => {
        this.handleError();
      }
    });
  }

  private handleError(): void {
    this.showError = true;
    this.showSpinner = false;
    this.profileForm.reset();
  }
}
